export const recommendedStoriesFetchDataSuccess = recommendedStories => ({
  type: 'RECOMMENDED_STORIES_FETCH_DATA_SUCCESS',
  recommendedStories
});

export const recommendedStoriesFetchData = (storyId) => {
  const endpoint = routes().get_story + storyId + '/recommended';
  const request = new Request(endpoint, {});

  return (dispatch) => {
    fetch(request)
      .then(response => response.json())
      .then(recommendedStories => dispatch(recommendedStoriesFetchDataSuccess(recommendedStories)));
  };
};
